import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';

import Select from '../common/inputs/select';
import Button from '../common/inputs/button';
import Spinner from '../common/interface/spinner';

import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const LoadDataHeader = props => {
  const {
    handleRefresh,
    handleInfo,
    selectedPolynomialIdModel,
    selectedPolynomialIdSubModel,
    filterPolynomialOptions,
    filterPolynomialSubModelOptions,
    onChangePolynomialFilter,
    polynomialFilterTreeInfoLoading,
    hideRefreshButton, // boolean: hide refresh virtual metrics button
    handleRefreshVirtualMetricData, //function: handler for refresh virtual metrics data button, already filtered by polynomial filter
    pendantVirtualMetricData, //array: virtual metric data with pending load
  } = props;
  
  let isPreModel = false
  let modelName = "" 
  if (selectedPolynomialIdModel != "") {
    modelName = filterPolynomialOptions.find(item => item.value == selectedPolynomialIdModel).label;
  }
  else if(selectedPolynomialIdSubModel != "") {
    modelName = filterPolynomialSubModelOptions.find(item => item.value == selectedPolynomialIdSubModel).label;
    isPreModel = true
  }
  let refreshVirtualMetricDataButtonLabel = (modelName==intl.formatMessage({ id: "periodAdmin.modelFilterAllOptionLabel" })) ? 
    modelName 
    : ((isPreModel ? 
        intl.formatMessage({ id: "common.entities.preModel" }) 
        : (intl.formatMessage({ id: "common.entities.model" })))
      + ": "+ modelName)

  return (
    <div className="load_data_section">
      <div className="entity_header period_admin_header">
        <div className='entity_title'>
           <FormattedMessage id="periodAdmin.loadDataTitle"/>
        </div>
        {(selectedPolynomialIdModel!="" || selectedPolynomialIdSubModel!="") && (
          <label className="refresh_button">
            <i className="fas fa-sync" onClick={handleRefresh}></i>
          </label>
        )}
        <label className="info_button">
          <i className="fas fa-info-circle" onClick={handleInfo}></i>
        </label>
      </div>
      <div className="model_filter_wrapper">
        <SelectWithTextBoxInput
          values={selectedPolynomialIdModel}
          onClickOption={onChangePolynomialFilter}
          addSelectLocale={ intl.formatMessage({ id: "periodAdmin.periodLoadDataFilterModelsLabel" })}
          options={filterPolynomialOptions}
          onClearTextCallback={onChangePolynomialFilter}
          data-path={"selectedPolynomialIdModel"}
          allowDisplayOptionsButton={true}
          className="model_filter"
        />
        {(filterPolynomialSubModelOptions && filterPolynomialSubModelOptions.length > 1) && (
          <SelectWithTextBoxInput
            values={selectedPolynomialIdSubModel}
            onClickOption={onChangePolynomialFilter}
            addSelectLocale={ intl.formatMessage({ id: "periodAdmin.periodLoadDataFilterSubModelsLabel" })}
            options={filterPolynomialSubModelOptions}
            onClearTextCallback={onChangePolynomialFilter}
            data-path={"selectedPolynomialIdSubModel"}
            allowDisplayOptionsButton={true}
            className="model_filter sub_model_filter"
          />
        )}
        {polynomialFilterTreeInfoLoading && (<Spinner/>)}
      </div>
      <label className="load_data_info">
        <FormattedMessage id={"periodAdmin.modelFilterAllOptionHelp"}/>
      </label>
      <div className="refresh_virtual_metrics_button_wrapper">
        {(!hideRefreshButton) && (
          <Button
            data-entitydata={JSON.stringify(pendantVirtualMetricData)}
            onClick={handleRefreshVirtualMetricData}
            labelLocale={(pendantVirtualMetricData["pendantVirtualMetricDataToLoadIds"].length>0) ?
              <FormattedMessage id="periodAdmin.refreshAllVirtualMetricDataButtonLabel" values={{model: refreshVirtualMetricDataButtonLabel}}/> 
              : <FormattedMessage id="periodAdmin.readyAllVirtualMetricDataButtonLabel" values={{model: refreshVirtualMetricDataButtonLabel}}/>}
            disabled={!(pendantVirtualMetricData["pendantVirtualMetricDataToLoadIds"].length>0)}
            className={(pendantVirtualMetricData["pendantVirtualMetricDataToLoadIds"].length>0) ? "virtual_metric_refresh_button_pending" : ""}
          />
        )}
      </div>
    </div>
  );
};

export default LoadDataHeader;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/loadDataHeader.jsx